
import { ReactComponent as mLogo } from "./logo/logo.svg";
import mWallet from "./login/e-wallet-rafiki.svg";
import mFinance from "./login/finance-rafiki.svg";
import mSaving from "./login/saving-money.svg";
import mMoney from "./login/money-income-rafiki.svg";

// Login Slider
export const Wallet = mWallet;
export const Finance = mFinance;
export const Saving = mSaving;
export const Money = mMoney;

// Logo
export const LogoSVG = mLogo;
